<template>
  <div class="split-view-container">
    <div class="split-view-pane left-pane">
      <slot name="left"></slot>
    </div>
    <div class="splitter" @mousedown="startDrag"></div>
    <div class="split-view-pane right-pane" :style="{ width: rightPaneWidth }">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const rightPaneWidth = ref('50%')
const isDragging = ref(false)

const startDrag = () => {
  isDragging.value = true
  document.body.style.cursor = 'col-resize'
  document.addEventListener('mousemove', handleDrag)
  document.addEventListener('mouseup', stopDrag)
}

const handleDrag = (e: MouseEvent) => {
  if (!isDragging.value) return
  
  const container = document.querySelector('.split-view-container') as HTMLElement
  if (!container) return
  
  const containerRect = container.getBoundingClientRect()
  const newWidth = ((containerRect.right - e.clientX) / containerRect.width) * 100
  
  // Constrain between 20% and 80%
  rightPaneWidth.value = `${Math.min(Math.max(newWidth, 20), 80)}%`
}

const stopDrag = () => {
  isDragging.value = false
  document.body.style.cursor = ''
  document.removeEventListener('mousemove', handleDrag)
  document.removeEventListener('mouseup', stopDrag)
}

onUnmounted(() => {
  document.removeEventListener('mousemove', handleDrag)
  document.removeEventListener('mouseup', stopDrag)
})
</script>

<style scoped>
.split-view-container {
  display: flex;
  height: 100%;
  width: 100%;
  position: relative;
}

.split-view-pane {
  height: 100%;
  overflow: auto;
}

.left-pane {
  flex: 1;
  min-width: 20%;
}

.right-pane {
  flex-shrink: 0;
}

.splitter {
  width: 8px;
  background-color: hsl(var(--border));
  cursor: col-resize;
  flex-shrink: 0;
  transition: background-color 0.2s;
}

.splitter:hover {
  background-color: hsl(var(--primary));
}
</style>
